import styled from 'styled-components'
import { colors } from '../../theme'

export const Span = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  border: none;
  background-color: transparent;
  cursor: pointer;
`

export const InputStyle = styled.input<{
  border: string
  sizeY: string
  sizeX: string
}>`
  outline: none;
  border: 1px solid ${colors.grey300};
  border-radius: 10px;
  margin-top: 20px; //retirar
  margin-bottom: 15px;
  font-size: 13px;
  padding: 15px;
  padding-right: 55px;

  border: 1.5px solid ${({ border }) => border};
  border-radius: 12px;
  width: ${({ sizeX }) => sizeX};
  height: ${({ sizeY }) => sizeY};
  font-size: 12px;
  margin-top: 15px;
`

/*
 * O respiro vertical do card e dele, nao dos filhos: antes vinha da `margin-top` da caixa de busca,
 * que sumiu quando ela virou item da barra de filtros (a margem desalinhava a busca dos botoes).
 * Como padding do proprio card, o espacamento nao depende de qual elemento aparece primeiro.
 */
export const DivInput = styled.div`
  padding: 16px 20px;
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.28);
  border-radius: 24px;
  margin-bottom: 20px;
  position: relative;
  background-color: ${colors.surface};
`

/*
 * Agora e um item da barra de filtros, lado a lado com os botoes. As margens verticais que o
 * InputStyle carrega vinham de quando a busca tinha linha propria e deslocavam a caixa 15px para
 * cima em relacao aos botoes; zeradas aqui, o alinhamento fica por conta do `align-items` da barra.
 */
export const ContainerInput = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  input {
    margin-top: 0;
    margin-bottom: 0;
  }
`

/*
 * Barra de filtros: UMA linha so, com tudo dentro — busca, os 6 botoes de filtro, o periodo e o
 * Limpar. Cada um e um item direto deste flex, entao eles fluem e vao descendo de linha conforme a
 * largura aperta, em vez de um grupo inteiro cair de uma vez (era o que acontecia quando os botoes
 * viviam num `Wrapper` proprio e o periodo numa linha separada).
 *
 * Tambem e a ancora dos paineis de filtro (todos filhos deste elemento), dai o `position: relative`:
 * como a linha quebra, os paineis nao podem ter `top`/`left` fixos em pixel — descolariam dos
 * botoes. Abrem sempre logo abaixo da barra inteira.
 */
export const DivFilter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  column-gap: 15px;
  row-gap: 10px;
  position: relative;
`

export const TypesFilter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  font-size: 12px;
  height: 42px;
  background: ${colors.grey200};
  border-radius: 8px;
  cursor: pointer;
`
/* Item da mesma barra dos filtros: largura preferida, mas encolhe ate caber quando a linha aperta. */
export const TypesFilterCalendar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  font-size: 12px;
  height: 42px;
  background: ${colors.grey200};
  border-radius: 8px;
  cursor: pointer;
  width: auto;
  max-width: 100%;
`
export const Filters = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: none;
  border: none;
  height: 100%;
  width: 100%;
  cursor: pointer;
`

export const FiltersCalendar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: none;
  width: 100%;
`

export const SearchCompanies = styled.input`
  border: none;
  width: 100%;
  padding-left: 10px;
`

export const FilterCompanie = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 0;
  top: calc(100% + 10px);
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: min(500px, 100%);
  z-index: 10;
`

export const FilterClient = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 0;
  top: calc(100% + 10px);
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: min(500px, 100%);
  z-index: 10;
`

export const FilterProduct = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 0;
  top: calc(100% + 10px);
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: min(500px, 100%);
  z-index: 10;
`

export const FilterSegmento = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 0;
  top: calc(100% + 10px);
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: min(400px, 100%);
  z-index: 10;
`

export const FilterCategoria = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 0;
  top: calc(100% + 10px);
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: min(400px, 100%);
  z-index: 10;
`

export const FilterSalesPeople = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 0;
  top: calc(100% + 10px);
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: min(500px, 100%);
  z-index: 10;
`

export const FilterDate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.6);
  position: absolute;
  left: 550px;
  top: 68px;
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 20px;
  width: 680px;
  z-index: 10;
  @media screen and (max-width: 1400px) {
    left: 420px;
  }
`
export const Calendars = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 20px;
  font-size: 20px;
`
export const OptionActive = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 10px;
`

export const Option = styled.div`
  height: 30px;
  padding: 0px 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${colors.grey900};
  font-weight: 500;
  font-size: 12px;
  line-height: 2em;
  text-align: left;
  margin-right: 15px;
  margin-top: 5px;
  border-radius: 4px;
  background-color: ${colors.grey50};
  border: solid 1px ${colors.grey200};
  box-shadow: 7px 5px 7px rgba(0, 0, 0, 0.28);
`

export const Filtro = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`

export const DatePickerStyle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  gap: 10px;
  margin-left: 5px;
`
